module.exports = __webpack_public_path__ + "img/company_04.d812c869.png";